var currentTier;
var amount;
class VIPTiers {
  constructor(vipTiers,vipTiersSetting,customer) {
    //this.baseTier = baseTier;
   // this.vipTiers = [this.baseTier, ...vipTiers];
    this.vipTiers=vipTiers;
    this.vipTiersSetting = vipTiersSetting;
    this.customer = customer;

  }
    renderVIPTiers() {
      // this.vipTiers[0].name = "Silver";
      // this.vipTiers[1].name = "Gold";
      // this.vipTiers[2].name = "Platinum";
            this.vipTiers.forEach((vipTier,index1) => {
                 if(vipTier.pointsMultiplier[vipTier.pointsMultiplier.length-1] == '0') {
                    vipTier.pointsMultiplier = vipTier.pointsMultiplier.substring(0,vipTier.pointsMultiplier.length-2)
                 }
                $(".swell-vip-tiers-setting").append(
                    $("<div>").addClass("swell-table-tier").append (
                      $("<p>").addClass("swell-tier-spend"),
                      $("<div>").addClass("swell-tier-text").append(
                        $("<div>").addClass("swell-tier-current-details"),
                        $("<div>").addClass("swell-tier-title").append(
                          $("<p>").text(vipTier.name.replace("VIP","").toString()).addClass("swell-tier-name"),
                          $("<div>").addClass("swell-vip-tier-require-points")),
                          //$("<p>").text(`${vipTier.pointsMultiplier}X `).addClass("swell-points-multiplier"),
                          $("<div>").addClass("swell-tier-details").append(
                            $("<p>").text("BENEFITS").addClass("swell-benefits"),
                          $("<p>").text(`1- ${vipTier.pointsMultiplier}X Point multiplier`)
                          ))
                        ))
            
                if(index1==0) {
                    $(`.swell-table-tier:nth-of-type(${index1+1}) .swell-vip-tier-require-points`).append(
                      $("<p>").text("Entry conditions"),
                      $("<p>").text("Create An Account"))
                
                }

                if(index1==1) {
                  console.log(vipTier.swellrequiredAmountSpent)
                    $(`.swell-table-tier:nth-of-type(${index1+1}) .swell-vip-tier-require-points`).append(
                      $("<p>").text("Entry conditions"),
                      $("<p>").text(vipTier.description))
                   
                }
                if(index1==2){
                    $(`.swell-table-tier:nth-of-type(${index1+1}) .swell-vip-tier-require-points`).append(
                      $("<p>").text("Entry conditions"),
                      $("<p>").text(vipTier.description))
                }
                

                this.vipTiersSetting.forEach((vipTierSet,index2) => {
                  if ((vipTierSet.option[`${index1}`])!== "") {
                    $(`.swell-table-tier:nth-of-type(${index1+1}) .swell-tier-details`).append(
                      $("<div>").append(
                        $("<p>").text(`${index2+2}- `),
                        $("<p>").text(vipTierSet.option[`${index1}`])
                      ).addClass("swell-tier-detail-p")
                    )}
                })

            })

      
         this.generateTierStatusPointer();
             var newscript = document.createElement('script');
             newscript.type = 'text/javascript';
             newscript.async = true;
             //newscript.src = 'https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js';
          (document.getElementsByTagName('head')[0]||document.getElementsByTagName('body')[0]).appendChild(newscript);

            setTimeout(function() {
            $(".swell-vip-tiers-setting").slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                responsive: [
                  {breakpoint: 1000, settings: {slidesToShow: 2, slidesToScroll: 1,infinite: false, initialSlide: currentTier,dots:true}},
                  {breakpoint: 650, settings: {slidesToShow:1, slidesToScroll: 1, infinite: false, initialSlide: currentTier,dots:true}},
               ]
            });
            }, 300);
    }
    generateTierStatusPointer() {
        if(this.customer.created_at !== undefined) {
             currentTier = null;
            if(this.customer.vipTier !== null) {
              currentTier = this.vipTiers.map(tier => tier.name).indexOf(this.customer.vipTier.name);
              $(`.swell-table-tier:nth-of-type(${currentTier + 1}) .swell-tier-current-details`).text("CURRENT STATUS");
              $(`.swell-table-tier:nth-of-type(${currentTier + 1})`).addClass("swell-current-tier");
            } 
             if (currentTier===null) {
                // $(".swell-table-tier:nth-of-type(1) .swell-tier-details").append(
                //   $("<p>").text(
                //     `Spend $1 to earn ${(this.vipTiers[0].name).replace("VIP","").toString()}`)
                //   .addClass("swell-tier-spend"));
              } else {
             if(currentTier  < swellAPI.getVipTiers().length) {
               amount = ((this.vipTiers[currentTier + 1].swellrequiredAmountSpentCents - swellAPI.getCustomerDetails()
                    .vipTierStats.amountSpentCents)/100).toString();

              if (amount.includes(".")) {
                amount = `${amount}0`;
              }


                $(`.swell-table-tier:nth-of-type(${currentTier + 2}) .swell-tier-spend`)
                 .text(
                    `Spend $${amount} to earn ${(this.vipTiers[currentTier+1].name).replace("VIP","").toString()}`)
                  ;
          
              }
            }
             
          
        }
   }
}
 